import { z } from "zod"

export const UsernameSchema = z
	.string({ required_error: "Nombre de usuario requerido" })
	.min(3, { message: "Nombre de usuario demasiado corto" })
	.max(20, { message: "Nombre de usuario demasiado largo" })
	.regex(/^[a-zA-Z0-9_]+$/, {
		message:
			"Nombre de usuario sólo puede incluir letras, números y barras bajas",
	})
	// users can type the username in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const PasswordSchema = z
	.string({ required_error: "Contraseña requerida" })
	.min(6, { message: "Contraseña demasiado corta" })
	.max(100, { message: "Contraseña demasiado larga" })
export const FirstNameSchema = z
	.string({ required_error: "Nombre de pila requerido" })
	.min(2, { message: "Nombre de pila demasiado corto" })
	.max(40, { message: "Nombre de pila demasiado largo" })
export const LastNameSchema = z
	.string({ required_error: "Apellido requerido" })
	.min(2, { message: "Apellido demasiado corto" })
	.max(40, { message: "Apellido demasiado largo" })
export const EmailSchema = z
	.string({ required_error: "Correo electrónico requerido" })
	.email({ message: "Correo electrónico no válido" })
	.min(3, { message: "Correo electrónico demasiado corto" })
	.max(100, { message: "Correo electrónico demasiado largo" })
	// users can type the email in any case, but we store it in lowercase
	.transform(value => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = z
	.object({ password: PasswordSchema, confirmPassword: PasswordSchema })
	.superRefine(({ confirmPassword, password }, ctx) => {
		if (confirmPassword !== password) {
			ctx.addIssue({
				path: ["confirmPassword"],
				code: "custom",
				message: "Las contraseñas deben coincidir",
			})
		}
	})
